/**
 * Liens Dashboard → Analytics (option B : drill-down sur /analytics).
 */

const VALID_SECTIONS = [
  'revenus',
  'commandes',
  'commandes-evolution',
  'commandes-repartition',
  'produits',
  'traffic',
  'system',
  'catalogue',
];

/**
 * @param {{
 *   section?: string,
 *   period?: string,
 *   dateDebut?: string,
 *   dateFin?: string,
 *   commercantId?: string,
 * }} params
 */
export function buildAnalyticsUrl({
  section,
  period = '30j',
  dateDebut,
  dateFin,
  commercantId,
} = {}) {
  const params = new URLSearchParams();
  if (section && VALID_SECTIONS.includes(section)) {
    params.set('section', section);
  }
  if (dateDebut && dateFin) {
    params.set('dateDebut', dateDebut);
    params.set('dateFin', dateFin);
    params.set('period', 'custom');
  } else if (period) {
    params.set('period', period);
  }
  if (commercantId && commercantId !== 'all') {
    params.set('commercantId', commercantId);
  }
  const qs = params.toString();
  return `/analytics${qs ? `?${qs}` : ''}`;
}

export { VALID_SECTIONS };
